



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { comdify2 } from '@/utils/validate'
@Component
export default class ProductOutFormInfo extends Vue {
    @Prop() item!: {}
    @Prop() name!: string
    comdify2 = comdify2
}
